module.exports = __webpack_public_path__ + "img/service_give_points.fb88733e.svg";